import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-save-order-dialog',
  imports: [
    MatDialogActions,
    MatDialogContent
  ],
  templateUrl: './save-order-dialog.html',
  styleUrl: './save-order-dialog.css'
})
export class SaveOrderDialog {

  constructor(public dialogRef: MatDialogRef<SaveOrderDialog>) {

  }

  saveAsDraft() {
    this.dialogRef.close(true)
  }

  close() {
    this.dialogRef.close(false)
  }
}
